import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './SessionTrackerPage.css';
import SessionList from './SessionList';
import CreateSession from './CreateSession';
import SessionDetail from './SessionDetail';

export default function SessionTrackerPage() {
  return (
    <div className="session-tracker-page">
      <Routes>
        <Route index element={<SessionList />} />
        <Route path="new" element={<CreateSession />} />
        <Route path=":id" element={<SessionDetail />} />
      </Routes>
    </div>
  );
}
